const PRISMIC_REGEX = /^Prismic/

export function getSliceTypeName(slice: { __typename: string }) {
  return slice?.__typename ? slice.__typename.replace(PRISMIC_REGEX, '') : ''
}
